import script from "./TheCuponesTienda.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheCuponesTienda.vue?vue&type=script&lang=ts&setup=true"

import "./TheCuponesTienda.vue?vue&type=style&index=0&id=78e584e1&scoped=true&lang=css"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78e584e1"]])

export default __exports__